import React from 'react'

const Header = () => {
    return (
        <header className="site-header">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-12 d-flex flex-wrap">
                        <p className="d-flex me-4 mb-0">
                            <i className="bi bi-music-note-beamed me-2"></i>
                            <strong className="text-dark">
                                #BeatlesCover Acoustic Trio
                            </strong>
                        </p>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header